import React from 'react';
import Layout from '../../components/Layout';
import CompanyAccount from './CompanyAccount';

const title = 'Company Account — BestHand for Companies';
const description =
  'Manage your company account: referral code, services, payout bank account, '
  + 'legal & support, and account deletion.';

async function action({ largeProjectsEnabled }) {
  // LARGE PROJECTS FLAG: when OFF this LP route is unreachable -> redirect home
  // (additive guard; small-jobs routes untouched), same as /company/projects.
  if (!largeProjectsEnabled) {
    return { redirect: '/' };
  }
  return {
    title,
    description,
    component: (
      <Layout companyMode>
        <CompanyAccount />
      </Layout>
    ),
  };
}

export default action;
